import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useTranslation } from '@wix/wix-i18n-config';
import withExperiment from '../../../app/hoc/with-experiment';
import { EXPERIMENT_ICU_TRANSLATIONS } from '@wix/communities-forum-client-commons/dist/src/constants/experiments';

import { omit } from 'lodash';
import { translate } from 'react-i18next';
import uri from 'urijs';

const showKeys =
  typeof window !== 'undefined' && uri(window.location).hasQuery('debug-translate', 'true');

export default function withTranslate(WrappedComponent) {
  const WithTranslate = props => {
    const propsNew = omit(props, ['i18nLoadedAt']);
    const [t] = useTranslation();

    if (props.isICUEnabled) {
      propsNew.t = t;
    }

    if (showKeys) {
      propsNew.t = key => key;
    }

    return <WrappedComponent {...propsNew} />;
  };

  hoistNonReactStatics(WithTranslate, WrappedComponent);

  return withExperiment({ isICUEnabled: EXPERIMENT_ICU_TRANSLATIONS })(
    translate(['translation'])(WithTranslate),
  );
}
